<div class="flex flex-jc-start flex-ai-center gapi-10">
	<div>
		<a href="{{loginByGoogleEndpoint}}">
			<img src="./assets/logo-google-light.svg" class="chi-8">
		</a>
	</div>
	<div>
		<a href="{{loginByFacebookEndpoint}}">
			<img src="./assets/logo-facebook-light.svg" class="chi-8">
		</a>
	</div>
</div>